const util = {
  isPhone() {
    var sUserAgent = navigator.userAgent.toLowerCase(),
      bIsIpad = sUserAgent.match(/ipad/i) == 'ipad',
      bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os',
      bIsMidp = sUserAgent.match(/midp/i) == 'midp',
      bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4',
      bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb',
      bIsAndroid = sUserAgent.match(/android/i) == 'android',
      bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce',
      bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile',
      bIsMS = sUserAgent.match(/mobile safari/i) == 'mobile safari'
    // 当前为电脑网站，如果是手机访问者跳转到手机网站中
    if (
      (bIsIpad ||
        bIsIphoneOs ||
        bIsMidp ||
        bIsUc7 ||
        bIsUc ||
        bIsAndroid ||
        bIsCE ||
        bIsWM ||
        bIsMS) &&
      '<%=redirectDomain %>' != ''
    ) {
      return true
    } else {
      return false
    }
  },

  isEmptyObject(obj) {
    for (var key in obj) {
      return false
    }
    return true
  },

  /**
   * 把url的参数部分转化成json对象
   * @param {*} url
   */
  parseQueryString(url) {
    var reg_url = /^[^\?]+\?([\w\W]+)$/,
      reg_para = /([^&=]+)=([\w\W]*?)(&|$|#)/g,
      arr_url = reg_url.exec(url),
      ret = {}
    if (arr_url && arr_url[1]) {
      var str_para = arr_url[1],
        result
      while ((result = reg_para.exec(str_para)) != null) {
        ret[result[1]] = result[2]
      }
    }
    return ret
  },

  /**
   * 判断是否是图片
   * @param {*} fileName 文件名称
   */
  isImage(fileName) {
    fileName = fileName.toLocaleLowerCase()
    if (
      this.endWith(fileName, '.jpg') ||
      this.endWith(fileName, '.jpeg') ||
      this.endWith(fileName, '.gif') ||
      this.endWith(fileName, '.png') ||
      this.endWith(fileName, '.bmp')
    ) {
      return true
    } else {
      return false
    }
  },

  /**
   * 判断是否以指定字符串结尾
   * @param {*} endStr
   */
  endWith(str, endStr) {
    var d = str.length - endStr.length
    return d >= 0 && str.lastIndexOf(endStr) == d
  },

  /**
   * 判断是否以指定字符串开始
   * @param {*} startStr
   */
  startWith(str, startStr) {
    return str.indexOf(startStr) == 0
  },

  /**
   * 将OriginalStr中的所有reallyDo替换成replaceWith
   * @param {*} OriginalStr
   * @param {*} reallyDo
   * @param {*} replaceWith
   * @param {*} isGlobal 是否全局替换，默认为true，全局替换
   */
  replaceAll(OriginalStr, reallyDo, replaceWith, isGlobal = true) {
    if (isGlobal) {
      return OriginalStr.replace(new RegExp(reallyDo, 'g'), replaceWith)
    } else {
      return OriginalStr.replace(new RegExp(reallyDo), replaceWith)
    }
  },

  /**
   * 将字符串转换成h5内容
   * @param {*} OriginalStr
   */
  strToH5Str(OriginalStr) {
    if (!OriginalStr) {
      return ''
    }
    OriginalStr = this.replaceAll(OriginalStr, '<', '&lt;')
    OriginalStr = this.replaceAll(OriginalStr, '>', '&gt;')
    OriginalStr = this.replaceAll(OriginalStr, '\r\n', '<br>')
    OriginalStr = this.replaceAll(OriginalStr, '\r', '<br>')
    OriginalStr = this.replaceAll(OriginalStr, '\n', '<br>')
    OriginalStr = this.replaceAll(OriginalStr, '\t', '&nbsp;&nbsp;&nbsp;&nbsp;')
    OriginalStr = this.replaceAll(OriginalStr, ' ', '&nbsp;&nbsp;')
    return OriginalStr
  },

  /**
   * 截取字符串
   * @param val 原字符串
   * @param prefix 前缀
   */
  subStr(val, prefix) {
    return val.substring(prefix.length, val.length)
  },
  /**
   * 如果dest中存在src同名属性，则将src中对应值赋值给dest中属性
   */
  copy(src, dest) {
    if (!src || !dest) {
      return
    }
    for (var key in src) {
      if (dest[key] !== undefined) {
        dest[key] = src[key]
      }
    }
  },
  copyObj2Obj(obj1, obj2) {
    for (var key in obj2) {
      obj1[key] = obj2[key]
    }
  },

  href(uri, router) {
    let base = router ? router.options.base : ''
    if (base.length > 0 && base.substr(0, 1) !== '/') {
      base = '/' + base
    }
    console.log(base.substr(base.length - 1, 1))
    console.log(uri.substr(0, 1))
    const uriFlag = uri.substr(0, 1) === '/'
    if (base.substr(base.length - 1, 1) === '/') {
      if (uriFlag) {
        base = base.substr(0, base.length - 1)
      }
    } else if (!uriFlag) {
      base = base + '/'
    }
    location.href = base + uri
  }
}
export default util



// WEBPACK FOOTER //
// ./src/api/utils/util.js